<template>
  <v-container>
    <h2>
    マイ機器QRコードを印刷する
    </h2>
    <br>
    <div class="mb-3 body-2">
      マイ機器QRコードは登録したマイ機器ごとに発行されます。<br>QRコードをシール台紙に印刷して機器に貼り付けることができます。
    </div>

    <div class="mt-8 mb-4">
      <v-card  outlined color="teal" class="mx-auto" max-width="90%">
        <v-card-title>
          <v-icon color="white">mdi-qrcode</v-icon>
          <span class="white--text body-1 font-weight-light">マイ機器QRコードのメリット</span>          
        </v-card-title>
        <v-card-text class="body-2 white--text">
          スマートフォンやタブレットでQRコードを読み取ると、「分析サンプルの採取登録」画面にダイレクトにアクセスすることができます。<br>
          機器からサンプルを採取したその場ですぐに登録することができるので、採油作業の効率アップになります。
        </v-card-text>
      </v-card>
    </div>

    <div class="mb-3 body-2">
      マイ機器QRコードの印刷はマイ機器メニューから行います。
    </div>

    <div class="my-8 mb-4">
      <h3>マイ機器メニューの表示</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      マイ機器マイ機器メニューは画面上部の「メニュー」から、「マイ機器」を選択します。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-machine-edit-01.png" width="70%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>マイ機器更新画面を開く</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器画面にあるマイ機器リストの中から、QRコードを印刷したい機器をクリックします。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-edit-08.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器情報更新画面の上部にある「マイ機器QRコードを確認」ボタンをクリックします。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-qr-print-01.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器QRコードシート画面が開きます。画面左上にある「QRコードを印刷する」ボタンをクリックします。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-qr-print-02.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 mt-10 body-2">
      マイ機器QRコードシートのプリントプレビュー画面が開きます。用紙サイズをA4に設定し、「印刷」ボタンをクリックすることで印刷します。<br>
      印刷するプリンタに24カットシール紙をセットして印刷してください。マイ機器QRコードシートは24カットシール紙に最適化されています。
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-machine-qr-print-03.png" width="90%" class="my-2">
    </div>

  </v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: ''
    }),
    methods: {
    }
}
</script>

